import React, { useEffect } from 'react';

import { useViewportHeight } from 'hooks/useViewportHeight';
import { logger } from 'utils/logger';

interface ViewportHeightProviderProps {
  children: React.ReactNode;
}

export const ViewportHeightProvider: React.FC<ViewportHeightProviderProps> = ({ children }) => {
  const { vh, realHeight, isSafari, isMobile } = useViewportHeight();

  useEffect(() => {
    // Apply CSS variables dynamically
    const root = document.documentElement;

    // Set the real viewport height
    root.style.setProperty('--vh', `${vh}px`);
    root.style.setProperty('--real-vh', `${realHeight}px`);

    // For Safari on iOS, apply specific adjustments
    if (isSafari && isMobile) {
      root.style.setProperty('--safari-vh', `${realHeight}px`);

      // Add specific class for Safari iOS
      document.body.classList.add('safari-ios');
    } else {
      document.body.classList.remove('safari-ios');
    }

    // Add class for mobile devices
    if (isMobile) {
      document.body.classList.add('mobile-device');
    } else {
      document.body.classList.remove('mobile-device');
    }

    logger.debug('[ViewportHeightProvider]', {
      vh,
      realHeight,
      isSafari,
      isMobile,
      safeAreaBottom: getComputedStyle(root).getPropertyValue('--safe-area-inset-bottom'),
    });
  }, [vh, realHeight, isSafari, isMobile]);

  return <>{children}</>;
};

export default ViewportHeightProvider;
